import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';

import Navbar from './screens/navbar';
import Carousel from './screens/carrusel';
import Maps from './screens/maps'; 

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import ReviewSection from './screens/resenias';
import Footer from './screens/footer';
import Chatbot from './components/Chatbot';
import Nosotros from './vistas/nosotros'; 
import Contact from './vistas/Contact';   
import Services from './vistas/Services'; 
import Camiones from './vistas/Camiones';
import Seguimiento from './vistas/Seguimiento';
import Cotizaciones from './vistas/cotizaciones';
import InicioSesion from './vistas/iniSes';
import Register from './vistas/register';
import Trabajadores from './vistas/trabajadores';
import Seguros from './vistas/seguro';
import MetodosPago from './vistas/metodosPago';
import PreguntasFrecuentes from './vistas/preguntasFrecuentes';
import RecuperarContrasena from './vistas/recuperarContrasena';
import TrabajaConNosotros from './vistas/TrabajaConNosotros'; 
import Embalaje from './vistas/embalaje';
import './App.css';
import Resenas  from './vistas/resenas';
import Perfil  from './vistas/Perfil';
import Payments from './vistas/Pagos';
import PaymentsML from './vistas/pago_ml';




function Home() {
  const navigate = useNavigate();

  const goToCotizaciones = () => {
    navigate('/cotizaciones');
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Carousel />
      
      <div className="relative -mt-20 z-20">
        <div className="flex justify-center">
          <button
            onClick={goToCotizaciones}
            className="bg-[#8B0000] hover:bg-[#A52A2A] text-white font-bold py-4 px-12 rounded-full text-xl transition-all duration-300 transform hover:scale-105 shadow-xl hover:shadow-2xl flex items-center gap-2"
          >
            <span>Cotiza aquí</span>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
            </svg>
          </button>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <ReviewSection max={4} />
      </div>


      {/* Sección: Por qué elegirnos */}
      <div className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-center text-[#8B0000] mb-12">¿Por qué elegir Frabas?</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Tarjeta 1 */}
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-[#8B0000] rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-center mb-4">Servicio 24/7</h3>
              <p className="text-gray-600 text-center">Disponibles cuando nos necesites. Nuestro equipo está listo para ayudarte en cualquier momento.</p>
            </div>

            {/* Tarjeta 2 */}
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-[#8B0000] rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-center mb-4">100% Seguro</h3>
              <p className="text-gray-600 text-center">Tus pertenencias están aseguradas. Garantizamos un servicio seguro y confiable.</p>
            </div>

            {/* Tarjeta 3 */}
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-[#8B0000] rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-center mb-4">Precios Justos</h3>
              <p className="text-gray-600 text-center">Tarifas competitivas y transparentes. Sin costos ocultos.</p>
            </div>
          </div>
        </div>
      </div>


      {/* NUEVO APARTADO: Tu mudanza en 2 pasos */}
      <div className="w-full bg-white py-16 px-4">
  <div className="max-w-3xl mx-auto bg-gradient-to-br from-white via-gray-50 to-gray-100 rounded-3xl shadow-2xl p-10 border border-gray-100 flex flex-col items-center text-center">   
    <h2 className="text-4xl font-extrabold text-[#8B0000] mb-10 drop-shadow">
      Tu mudanza en 2 pasos
    </h2>
    <ol className="list-decimal list-inside text-lg text-gray-700 space-y-6 max-w-md w-full text-left">
      <li className="flex items-start">
        <div className="flex-shrink-0 w-8 h-8 bg-[#8B0000] text-white rounded-full font-bold flex items-center justify-center shadow mr-4">
          1
        </div>
        <span className="font-semibold text-black">
          Ingresa los datos de tu mudanza en 1 minuto.
        </span>
      </li>
      <li className="flex items-start">
        <div className="flex-shrink-0 w-8 h-8 bg-[#8B0000] text-white rounded-full font-bold flex items-center justify-center shadow mr-4">
          2
        </div>
        <span className="font-semibold text-black">
          Relájate, nosotros nos encargamos del resto.
        </span>
      </li>
    </ol>
    <button
      onClick={goToCotizaciones}
      className="bg-gradient-to-r from-[#8B0000] to-[#A52A2A] hover:from-[#A52A2A] hover:to-[#8B0000] text-white font-bold py-3 px-12 rounded-full text-lg transition-all duration-300 transform hover:scale-105 shadow-lg mt-10"
    >
      Cotiza gratis
    </button>
  </div>
</div>

      {/* Nueva sección: Nuestros Servicios */}
      <div className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-extrabold text-center text-[#8B0000] mb-14 drop-shadow">Nuestros Servicios</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {/* Servicio 1 */}
            <div className="relative group rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-shadow bg-white">
              <img src="/camiones/camion1.png" alt="Mudanzas Locales" className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300" />
              <div className="absolute inset-0 bg-[#8B0000]/70 group-hover:bg-[#A52A2A]/80 transition-colors duration-300"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-6">
                <h3 className="text-2xl font-bold mb-2 drop-shadow">Mudanzas Locales</h3>
                <p className="text-center text-lg">Servicio profesional para mudanzas dentro de la ciudad</p>
              </div>
            </div>
            {/* Servicio 2 */}
            <div className="relative group rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-shadow bg-white">
              <img src="/mudanzas-nacional.png" alt="Mudanzas Nacionales" className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300" />
              <div className="absolute inset-0 bg-[#8B0000]/70 group-hover:bg-[#A52A2A]/80 transition-colors duration-300"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-6">
                <h3 className="text-2xl font-bold mb-2 drop-shadow">Mudanzas Nacionales</h3>
                <p className="text-center text-lg">Traslados seguros a cualquier punto del país</p>
              </div>
            </div>
            {/* Servicio 3 */}
            <div className="relative group rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-shadow bg-white">
              <img src="/internacional.png" alt="Mudanzas Internacionales" className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300" />
              <div className="absolute inset-0 bg-[#8B0000]/70 group-hover:bg-[#A52A2A]/80 transition-colors duration-300"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-6">
                <h3 className="text-2xl font-bold mb-2 drop-shadow">Mudanzas Internacionales</h3>
                <p className="text-center text-lg">Experiencia en traslados internacionales</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sección: Llamada a la acción final */}
      <div className="bg-[#8B0000] text-white py-16">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">¿Listo para tu próxima mudanza?</h2>
          <p className="text-xl mb-8">Obtén una cotización gratuita y personalizada en minutos</p>
          <button
            onClick={goToCotizaciones}
            className="bg-white text-[#8B0000] hover:bg-gray-100 font-bold py-4 px-12 rounded-full text-xl transition-all duration-300 transform hover:scale-105 shadow-xl"
          >
            Cotiza ahora
          </button>
        </div>
      </div>

    </div>
  );
}

function App() {
  const [showChatbot, setShowChatbot] = React.useState(false);

  return (
    <Router>
      <div className="App">
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path='/camiones' element={<Camiones/>} />
          <Route path= '/seguimiento' element={<Seguimiento/>} />
          <Route path= '/cotizaciones' element={<Cotizaciones/>} />
          <Route path='/iniciosesion' element={<InicioSesion/>} />
          <Route path='/register' element={<Register/>} />
          <Route path='/trabajadores' element={<Trabajadores/>} />
          <Route path='/seguros' element={<Seguros/>} />
          <Route path='/metodospagos' element={<MetodosPago/>} />
          <Route path='/preguntas' element={<PreguntasFrecuentes/>} />
          <Route path='/recuperar' element={<RecuperarContrasena/>} />
          <Route path='/trabaja-con-nosotros' element={<TrabajaConNosotros/>} />
          <Route path='/embalaje' element={<Embalaje/>} /> 
          <Route path='/resenas' element={<Resenas/>} />    
          <Route path='/perfil' element={<Perfil/>} />   
          <Route path='/pagos/:trackingCode' element={<Payments/>} /> 
          <Route path="/pago-ml/:trackingCode" element={<PaymentsML />} />
          {/* Rutas adicionales */}


        
        </Routes>

        {/* Botones flotantes: WhatsApp y Chatbot */}
        <div className="fixed bottom-4 right-4 flex flex-col items-end gap-3 z-50">
          {/* WhatsApp */}
          <a
            href="https://wa.me/56966282340"
            className="bg-green-500 text-white p-5 rounded-full shadow-lg hover:bg-green-700 transition-colors"
            target="_blank"
            rel="noopener noreferrer"
            style={{ boxShadow: '0 4px 16px #0002' }}
          >
            <FontAwesomeIcon icon={faWhatsapp} className="w-7 h-7" />
          </a>
          {/* Chatbot */}
          <button
            onClick={() => setShowChatbot((v) => !v)}
            className="bg-[#8B0000] hover:bg-[#A52A2A] text-white p-5 rounded-full shadow-lg transition-colors flex items-center justify-center"
            style={{ boxShadow: '0 4px 16px #0002' }}
            aria-label="Abrir chatbot"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8h2a2 2 0 012 2v8a2 2 0 01-2 2H7a2 2 0 01-2-2V10a2 2 0 012-2h2m2-4h4a2 2 0 012 2v4a2 2 0 01-2 2h-4a2 2 0 01-2-2V6a2 2 0 012-2z" />
            </svg>
          </button>
        </div>

        {/* Ventana del Chatbot */}
        {showChatbot && (
          <div
            className="fixed right-4 bottom-24 md:bottom-4 md:right-24 z-50"
            style={{ maxWidth: 360 }}
          >
            <Chatbot onClose={() => setShowChatbot(false)} />
          </div>
        )}

        <Footer />
      </div>
    </Router>
  );
}

export default App;
